import { Link, useLocation } from "react-router-dom";
import SEO from "@/components/SEO";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { SITE_URL } from "@/constants/seo";

interface GoneNoticeProps {
  /** Short heading, e.g. "Este centro ya no está disponible" */
  title: string;
  /** One or two sentences of context for the visitor. */
  description: string;
  /** Where to send the visitor instead. */
  backTo: string;
  backLabel: string;
}

/**
 * Rendered instead of a client-side redirect when the requested entity does
 * not exist. Client-side redirects made Google classify these URLs as
 * "Página con redirección" and, because no <SEO> ran, the static homepage
 * canonical leaked in ("Página alternativa con etiqueta canónica adecuada").
 * This keeps the URL stable, self-canonical and explicitly noindex.
 */
const GoneNotice = ({ title, description, backTo, backLabel }: GoneNoticeProps) => {
  const { pathname } = useLocation();

  return (
    <>
      <SEO
        title={title}
        description={description}
        canonical={`${SITE_URL}${pathname}`}
        noindex
      />
      <Navigation />
      <main className="min-h-[60vh] pt-32 lg:pt-40 pb-16">
        <div className="container mx-auto px-4 text-center max-w-2xl">
          <h1 className="text-3xl font-bold mb-4">{title}</h1>
          <p className="text-muted-foreground mb-8">{description}</p>
          <Button asChild>
            <Link to={backTo}>{backLabel}</Link>
          </Button>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default GoneNotice;
